export function setToken(val) {
	localStorage.setItem('token', val)
	localStorage.setItem('isLogin', true)
}

export function getToken() {
	return localStorage.getItem('token')
}

export function getIsLogin() {
	return localStorage.getItem('isLogin')
}

export function clearToken() {
	localStorage.removeItem('token')
	localStorage.removeItem('isLogin')
}

export function setUserInfo(val) {
	localStorage.setItem('userInfo', JSON.stringify(val))
}

export function getUserInfo() {
	return localStorage.getItem('userInfo')
}

export function userLoginOut() {
	clearToken()
	localStorage.removeItem('userInfo')
}

export function setAuditAuthority() {
	localStorage.setItem('auditAuthority', true)
}

export function getAuditAuthority() {
	return localStorage.getItem('auditAuthority')
}
